import React, { useEffect } from 'react';
import styles from './PropertyFinancingBox.scss';
import { IProperty } from '../utils/JsonApiRequest';
import useUser from '../stores/useUser';
import PropertyRequest from '../utils/PropertyRequest';
import ButtonRound from './ButtonRound';
import FinancingIcon from '../assets/img/financingicon.svg';
import Config from '../utils/Config';
import Affiliate from '../utils/Affiliate';
import LogError from '../utils/LogError';
import Button from './MaterialUi/Button';

export interface IPropertyFinancingProps {
    uuid: IProperty['id'];
}

const isTestModus = Config.get('environment') !== 'prod';

const baufiUrl = isTestModus
    ? 'https://wohnglueck.preview.impleco.de/frontend/template/wohnglueck-produkt.html?produkt=baufinanzierung-wohnglueck'
    : 'https://pia.wohnglueck.de/frontend/template/wohnglueck-produkt.html?produkt=baufinanzierung-wohnglueck';

const baufiHausbankUrl = isTestModus
    ? 'https://wohnglueck.preview.impleco.de/frontend/template/wohnglueck-produkt.html?produkt=hausbankbaufi-wohnglueck'
    : 'https://pia.wohnglueck.de/frontend/template/wohnglueck-produkt.html?produkt=hausbankbaufi-wohnglueck';

const browserAffiliate = Affiliate.getBrowserAffiliate();

const PropertyFinancingBox: React.FC<React.PropsWithChildren<IPropertyFinancingProps>> = ({ uuid = null }) => {
    const [user] = useUser();
    const [property, setProperty] = React.useState<IProperty>({} as IProperty);

    useEffect(() => {
        PropertyRequest.getProperty(uuid).then((propertyData) => {
            setProperty(propertyData);
        }).catch((error) => {
            console.error(error);
            LogError.add(error, {
                title: 'Fehler beim Laden der Immobilie für die Baufinanzierungs Box',
                error_code: 'PropertyFinancingBox:getProperty',
                request_data: { uuid },
            });
        });
    }, [user, uuid]);

    const affiliateId = user?.affiliateName || browserAffiliate;
    const url = Affiliate.isBankAffiliate(affiliateId) ? baufiHausbankUrl : baufiUrl;

    return (
        <>
            {property.type_of_marketing === 'buy' && property.property_type_parent_name !== 'commercial' && (
                <div className={styles.propertyFinancingBox}>
                    <div>
                        <h5>Top-Zins zum Immobilienkauf sichern!</h5>
                        <p className={styles.teaser}>
                            Sichere dir einen günstigen Immobilienkredit zur Top-Konditionen. Starte jetzt unseren digitalen Baufinanzeriung-Check!
                        </p>
                        <div className={styles.getPremiumButton}>
                            <a href={url} data-da-el-category="Verkettung" data-da-el-name="Baufinanzierung" data-da-el-interaction="view">
                                <Button size="extraLarge" sx={{ fontSize: '14px'}}>
                                    Jetzt Kredit berechnen
                                </Button>
                            </a>
                        </div>
                    </div>
                    <div className={styles.image}>
                        <FinancingIcon></FinancingIcon>
                    </div>
                </div>
            )}
        </>
    );
};

export default PropertyFinancingBox;
